import paymentMethodModel from '@/models/paymentMethod';

export async function fetchCheckoutSession({
	priceId,
	currency,
	attachPaymentMethod = false
}) {
	const { handlerData, originalAmount } = await paymentMethodModel.update({
		priceId,
		currency,
		attachPaymentMethod
	});

	handlerData.originalAmount = originalAmount;

	return handlerData;
}

export function waitForCardFormReady(container) {
	return new Promise(resolve => {
		function check() {
			const inputs = container.querySelectorAll(
				'.adyen-checkout__input-wrapper iframe'
			);

			const spinner = container.querySelector('.loading-input__spinner');

			const ready =
				inputs.length >= 3 &&
				(!spinner || window.getComputedStyle(spinner).display === 'none');

			if (ready) {
				resolve();
			}

			return ready;
		}

		if (check()) {
			return;
		}

		const observer = new MutationObserver(() => {
			if (check()) {
				observer.disconnect();
			}
		});

		observer.observe(container, {
			childList: true,
			subtree: true,
			attributes: true,
			attributeFilter: ['style', 'class']
		});
	});
}
